import axios from 'axios';
import { GET_DRS, GET_SPECIFIC_DR, ASK_DR, ANSWER_DR, DELETE_DR, CLEAR_DRS, DRS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IDr } from '../../types/interfaces';

export const getDrs = () => (dispatch: Function, getState: Function) => {
  // dispatch(setDrsLoading());
  dispatch({
    type: DRS_LOADING
  });
  axios
    .get('/api/drs', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_DRS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getDrById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: DRS_LOADING
  });
  axios
    .get('/api/drs/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_DR,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const askDr = (bien_id: number, user_id: number | undefined, username: string | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/drs/ask', {bien_id, user_id, username}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ASK_DR,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const answerDr = (id: number, contrat_id: number, bien_id: number, comId: number, comName: string, approved: number, isDg: number, isDc: number, isWb: number, recuFile: any, recuId: number, driveFileId: string, recu_image_counter: number, isAssociation: number, by_user_id: number | undefined, by_username: string | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/drs/answer', {id, contrat_id, bien_id, comId, comName, approved, isDg, isDc, isWb, recuFile, recuId, driveFileId, recu_image_counter, isAssociation, by_user_id, by_username}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ANSWER_DR,
        payload: res.data
      });
      callback(res.data, approved)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteDr = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/drs/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_DR,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearDrs = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_DRS
  })
};